/* eslint-disable */ import { memoEval, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const baseCabinet2DoorComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'default', true).withEntity('BaseCabinet2Door').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/higgins.glb',
            objectName: 'BFH24',
            dimensionUnit: 'inch'
        })))
];

//# sourceMappingURL=base-cabinet-2-door.js.map